module.exports = __webpack_public_path__ + "img/full_text_1.50f50a8d.png";